import React, { useState } from 'react'
import './App.css';
import { debounce, Grid } from '@material-ui/core';
import ProductOptions from './components/ProductOptions';
import Categories from './components/Categories';
import ProductReviews from './components/ProductReviews';
import ProductDetails from './components/ProductDetails';
import Products from './components/Products';
import Mobile from './Mobile';
import Desktop from './Desktop';

const App = () => {
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth
  });
  const elem = document.getElementById('root');
  console.log("ROOT", elem.attributes["type"]);
  // getunte-neuteile
  const productType = elem.attributes["type"] ? elem.attributes["type"].nodeValue : 'getunte-neuteile';

  React.useEffect(() => {
    const debouncedHandleResize = debounce(function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      })
    }, 100)

    window.addEventListener('resize', debouncedHandleResize)
    return _ => {
      window.removeEventListener('resize', debouncedHandleResize)
    }
  })

  const isMobile = dimensions.width <= 780 ? true : false;
  
  
  return (
    <>
      {isMobile ? <Mobile productType={productType} /> : <Desktop productType={productType} /> }
      
    </>
  );
}

export default App;
